<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="业务号">
              <div class="custom-select-container">
                <a-input
                  allow-clear
                  placeholder="请输入"
                  v-model="queryParam.business_no"
                >
                </a-input>
              </div>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="采销全流程">
              <a-select
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                show-search
                allow-clear
                v-model="queryParam.project_id"
                placeholder="请输入名称"
                :default-active-first-option="false"
                @search="this.projectSearch"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id" :tt="d.name">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24" v-if="false">
            <a-form-item label="付款方式">
              <div class="custom-select-container">
                <a-select
                  allow-clear
                  placeholder="付款方式"
                  v-model="queryParam.payment_method"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_credit_letter_payment_method">{{ val }}</a-select-option>
                </a-select>
              </div>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24" v-if="false">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleArchived">批量存档</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24" v-if="true">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1200 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="money_render" slot-scope="text" style="text-align: right; min-width: 90px; max-width: 180px">
        {{ (text / 1).toFixed(4) | numberFormat }}
      </div>
      <div slot="contract_type" slot-scope="category">
        <h4>{{ contractType(category) }}</h4>
      </div>
      <div slot="payment_reason" slot-scope="reason, record">
        {{ paymentApplicationReason(reason, record.contract_type.split(',')[0]) }}
      </div>
      <div slot="payee_account_render" slot-scope="text, record" style="text-align: center;">
        <a-popover>
          <template slot="content">
            <a-descriptions style="width: 800px" title="收款账户信息" size="small">
              <a-descriptions-item label="银行名称" v-if="record.bank_name">
                {{ record.bank_name }}
              </a-descriptions-item>
              <a-descriptions-item label="银行账号" v-if="record.bank_account">
                {{ record.bank_account }}
              </a-descriptions-item>
              <a-descriptions-item label="SWIFT CODE" v-if="record.swift_code">
                {{ record.swift_code }}
              </a-descriptions-item>
              <a-descriptions-item label="银行地址" v-if="record.bank_address">
                {{ record.bank_address }}
              </a-descriptions-item>
              <a-descriptions-item label="大额行号" v-if="record.cnaps_code">
                {{ record.cnaps_code }}
              </a-descriptions-item>
            </a-descriptions>
          </template>
          <a>{{ text }}</a>
        </a-popover>
      </div>
      <span slot="approval_needed" slot-scope="text, record">
        <a-popconfirm
          title="确定开启审批吗?"
          :disabled="text"
          @confirm="() => approvalNeeded(record, undefined, false)">
          <a-switch checked-children="是" un-checked-children="否" :checked="record.is_approval_needed" :disabled="record.is_approval_needed"/>
        </a-popconfirm>
      </span>
      <span slot="finished" slot-scope="text, record">
        <a-popconfirm
          :title="text?'确定修改付款状态吗？' : '确定已全部付完了吗？'"
          @confirm="() => applicationFinished(record)">
          <a-switch checked-children="是" un-checked-children="否" :checked="record.is_finished"/>
        </a-popconfirm>
      </span>
      <span slot="action" slot-scope="text, record" v-if="!record.is_archived">
        <template>
          <a @click="handleEdit(record)" v-if="record.status === 0 && isEdited(record.create_by_id)">编辑</a>
          <a-divider type="vertical" v-if="record.status !== 1 && isEdited(record.create_by_id)"/>
          <a-popconfirm
            v-if="record.status !== 1 && isEdited(record.create_by_id)"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" v-if="record.status !== 1 && isEdited(record.create_by_id)"/>
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-if="record.is_approval_needed && record.status === 3 && isEdited(record.create_by_id)">
                <a @click="approvalNeeded(record, 'payment_application', true)">重启审批</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleAttachment(record)">附件</a>
              </a-menu-item>
              <a-menu-item  v-if="!record.is_finished && ((record.is_approval_needed && record.status === 2) || record.status === 0)">
                <a @click="handlePayment(record)">付款</a>
              </a-menu-item>
              <a-menu-item v-if="((record.is_approval_needed && record.status === 2) || record.status === 0)">
                <a @click="handlePaymentRecord(record)">查看付款</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <archived-form
      ref="archivedModal"
      v-if="archivedVisible"
      :visible="archivedVisible"
      @cancel="handleArchivedCancel"
      @ok="handleArchivedOK"
    />
    <payment-create-form
      ref="createPaymentModal"
      v-if="paymentVisible"
      :visible="paymentVisible"
      :loading="confirmPaymentLoading"
      :model="mdl"
      @cancel="handlePaymentAddCancel"
      @ok="handlePaymentOk"/>
  </div>
</template>

<script>
import { STable } from '@/components'
import CreateForm from '../modules/CreateForm'
import PaymentCreateForm from '../../modules/CreateForm'
import debounce from 'lodash/debounce'
import { project_list } from '@/api/trade_project'
import {
  payment_application_create,
  payment_application_delete,
  payment_application_list,
  payment_application_update, payment_create
} from '@/api/trade_payment'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm,
    PaymentCreateForm
  },
  data () {
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      approval_again: false,
      loading: false,
      confirmLoading: false,
      // 创建窗口控制
      visible: false,
      archivedVisible: false,
      paymentVisible: false,
      confirmPaymentLoading: false,
      projectFetching: false,
      mdl: {},
      projectList: [],
      clientList: [],
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '业务号',
          dataIndex: 'business_no',
          width: 150,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '采销全流程',
          dataIndex: 'project',
          width: 150,
          ellipsis: true
        },
        {
          title: '合同类型',
          dataIndex: 'contract_type',
          width: 180,
          ellipsis: true,
          scopedSlots: { customRender: 'contract_type' }
        },
        {
          title: '合同号',
          dataIndex: 'contract_number',
          width: 150,
          ellipsis: true,
          customRender: (text, record) => text || record.contract_number
        },
        {
          title: '付款公司',
          dataIndex: 'payment_company',
          width: 180,
          ellipsis: true
        },
        {
          title: '收款公司',
          dataIndex: 'payee_company',
          width: 180,
          ellipsis: true
        },
        {
          title: '付款金额',
          dataIndex: 'payment_amount',
          align: 'right',
          width: 180,
          ellipsis: true,
          scopedSlots: { customRender: 'money_render' }
        },
        {
          title: '币种',
          dataIndex: 'payment_amount_currency',
          width: 140,
          ellipsis: true,
          align: 'center',
          customRender: (text, record) => this.$Dictionaries.currency[record.payment_amount_currency] || '无'
        },
        {
          title: '付款事由',
          dataIndex: 'payment_reason',
          width: 180,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'payment_reason' }
        },
        {
          title: '收款账户信息',
          dataIndex: 'bank_name',
          scopedSlots: { customRender: 'payee_account_render' },
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: '付款事由说明',
          dataIndex: 'payment_reason_desc',
          width: 180,
          ellipsis: true
        },
        {
          title: '开启审批',
          dataIndex: 'is_approval_needed',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'approval_needed' }
        },
        {
          title: '审批状态',
          dataIndex: 'status',
          align: 'center',
          width: 100,
          customRender: (text, record) => record.is_approval_needed ? this.$Dictionaries.approval_result[text] || '无' : '未开启审批'
        },
        {
          title: '是否已付完',
          dataIndex: 'is_finished',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'finished' }
        },
        {
          title: '创建人',
          dataIndex: 'create_by',
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: 180,
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData.parameter', parameter)
        return payment_application_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            console.log(res.data, '我是数据列表@')
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          getCheckboxProps: record => ({
            props: {
              disabled: record.is_archived
            }
          }),
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    if (this.$route.query && this.$route.query.id) {
      this.queryParam['id'] = this.$route.query.id
    }
  },
  computed: {
    contractType () {
      return (categories) => {
        return this.getLabelsByValues(categories.split(',')).join('/')
      }
    },
    paymentApplicationReason () {
      return (reason, contractType) => {
        if (contractType === '100') {
          return this.$Dictionaries.trade_payment_application_reasons[reason] || '无'
        } else if (contractType === '200') {
          return this.$Dictionaries.trade_payment_application_reasons2[reason] || '无'
        }
        return '无'
      }
    },
    isEdited () {
      return (create_by_id) => {
        const info = this.$store.state.user.info
        return create_by_id === info.id || create_by_id === -1
      }
    }
  },
  methods: {
    getLabelsByValues (values) {
      const vv = values.map((value) => {
        const v = this.getLabelByValue(Number(value))
        return v
      }).filter((value) => value !== undefined)
      return vv
    },
    getLabelByValue (value, categories = this.$Dictionaries.trade_related_contract) {
      for (const category of categories) {
        if (category.value === value) return category.label
        if (category.children) {
          const result = this.getLabelByValue(value, category.children)
          if (result) return result
        }
      }
      return undefined
    },
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            getCheckboxProps: record => ({
              props: {
                disabled: record.is_archived
              }
            }),
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      const date = new Date()
      const year = date.getFullYear()
      const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
      const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      // const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      // const second = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
      this.mdl = { business_no: year + '' + month + '' + day + '' + hours }
      this.visible = true
    },
    handleArchived () {
      if (this.selectedRowKeys.length > 0) {
        this.archivedVisible = true
      } else {
        this.$message.info('选择存档记录')
      }
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleArchivedCancel () {
      this.archivedVisible = false
      const form = this.$refs.archivedModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handlePaymentAddCancel () {
      this.paymentVisible = false
      const form = this.$refs.createPaymentModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handlePaymentOk (data) {
      const form = this.$refs.createPaymentModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          // 新增
          values['attachment'] = data['attachment']
          values['project_id'] = this.mdl.project_id
          values['contract_id'] = this.mdl.contract_id
          values['contract_type'] = this.mdl.contract_type
          values['application_id'] = this.mdl.id
          this.confirmPaymentLoading = true
          payment_create(values).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
              this.paymentVisible = false
              // 重置表单数据
              form.resetFields()
            }
          }).finally(() => {
            this.confirmPaymentLoading = false
          })
        }
      })
    },
    handleEdit (record) {
      this.$router.push({ path: '/trade/payment_application/' + record.id })
    },
    archived (record) {
      payment_application_update({ is_archived: !record.is_archived }, record.id).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    approvalNeeded (record, type, approval_again) {
      const is_approval_needed = approval_again ? true : !record.is_approval_needed
      if (is_approval_needed) {
        this.loading = true
        payment_application_update({ is_approval_needed: is_approval_needed }, record.id).then(res => {
          if (res.code === 1000) {
            this.$refs.table.refresh()
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    applicationFinished (record) {
      if ((record.is_approval_needed && record.status === 2) || record.status === 0) {
        payment_application_update({ is_finished: !record.is_finished }, record.id).then(res => {
          if (res.code === 1000) {
            this.$refs.table.refresh()
          }
        })
      } else {
        this.$message.warning('审批未通过')
      }
    },
    handleDelete (record) {
      payment_application_delete(record.id).then((res) => {
        console.log(res)
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleAttachment (record) {
      this.$router.push({ path: '/trade/payment_application/' + record.id + '/attachment' })
    },
    handlePayment (record) {
      console.log(record)
      this.mdl = record
      this.paymentVisible = true
    },
    handlePaymentRecord (record) {
      this.$router.push({ path: '/trade/payment/', query: { application_id: record.id } })
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          if (data && data['attachment']) {
            data['attachment'] = data['attachment'].map(item => {
              item['key'] = undefined
              return item
            })
          }
            // 新增
          values = { ...values, ...data }
          values['contract_type'] = values['contract_type'].join(',')
          payment_application_create(values).then(res => {
              this.visible = false
              // 重置表单数据
              form.resetFields()
              // 刷新表格
              if (res.code === 1000) {
                this.$refs.table.refresh()
              }
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleProjectSearch (value) {
      if (value === undefined || value === '') {
        return
      }
      this.projectFetching = true
      this.projectList = []
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleArchivedOK () {
      const form = this.$refs.archivedModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          const data = {
            ids: this.selectedRowKeys,
            ...values
          }
          payment_application_update(data).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.archivedVisible = false
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>
